import React from "react";
import Icons from "../../../../Constants/Icons";
import Colors from "../../../../Constants/Colors";
import StatusButton from "../../../../Components/StatusButton/StatusButton";
import moment from "moment";
import CopyToClipboard from "../../../../Components/CopyToClipboard";
import { useNavigate } from "react-router-dom";

function AstrologerInvoiceList({
  astrologerId,
  Astrologer,
  status,
  fromDate,
  paidDate,
  data,
  totalIncome,
  toDate,
  handleScroll,
  commentsContainerRef,
}) {
  const navigate = useNavigate();
  return (
    <div
      style={{
        alignSelf: "stretch",
        flex: 1,
        borderRadius: "8px",
        border: Colors.darkBorderColor,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "1rem",
      }}
    >
      <div
        style={{
          alignSelf: "stretch",
          flex: "1",
          backgroundColor: Colors.borderColor,
          borderBottom: Colors.darkBorderColor,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0.8rem",
        }}
      >
        <div style={{ width: "22%" }} className="contentName">
          {astrologerId}
        </div>

        <div style={{ width: "15%" }} className="contentName">
          {Astrologer}
        </div>

        <div
          style={{
            width: "15%",
            display: "flex",
            cursor: "pointer",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <div
            className="contentName"
            style={{
              fontWeight: "600",
            }}
          >
            {fromDate}
          </div>
        </div>

        <div
          style={{
            width: "15%",
            display: "flex",
            cursor: "pointer",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <div
            className="contentName"
            style={{
              fontWeight: "600",
            }}
          >
            {toDate}
          </div>
        </div>
        <div
          style={{
            width: "15%",
            display: "flex",
            cursor: "pointer",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <div
            className="contentName"
            style={{
              fontWeight: "600",
            }}
          >
            {paidDate}
          </div>
        </div>
        <div
          style={{
            width: "8%",
            display: "flex",
            cursor: "pointer",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <div
            className="contentName"
            style={{
              fontWeight: "600",
            }}
          >
            <div>{totalIncome}</div>
          </div>
        </div>

        <div style={{ width: "10%" }} className="contentName">
          {status}
        </div>
      </div>

      <div
        // style={{ maxHeight: "75vh" }}
        style={{ maxHeight: "calc(100vh - 16vh)" }}
        onScroll={handleScroll}
        ref={commentsContainerRef}
        className="scrollable-container"
      >
        {data.map((item, index) => (
          <div key={index}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                flex: 1,
                borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
                padding: "0.8rem",
                alignSelf: "stretch",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  width: "22%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: "0.5rem",
                    alignSelf: "stretch",
                  }}
                >
                  <div className="fontSize18Weight400">{item.astrologerId}</div>
                  <CopyToClipboard text={item.astrologerId}>
                    <img
                      style={{
                        cursor: "pointer",
                      }}
                      className="icon_copy"
                      alt=""
                      src={Icons.ic_copy}
                    />
                  </CopyToClipboard>
                </div>
              </div>

              <div
                style={{
                  width: "15%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  cursor: "pointer",
                  gap: "0.5rem",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  navigate("/AstrologerProfile", {
                    state: {
                      astrologerId: item?.astrologerId,
                    },
                  });
                }}
              >
                <div style={{}} className="indian-man-smiling-astrologer">
                  <img
                    style={{
                      position: "relative",
                      width: "2.63rem",
                      height: "2.63rem",
                    }}
                    alt=""
                    src={item?.astrologerImage}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                  }}
                >
                  <div className="fontSize18Weight400">
                    {item?.astrologerName}
                  </div>
                  <div
                    style={{ color: Colors.secondary }}
                    className="fontSize18Weight400"
                  >
                    {item?.astrologerRole}
                  </div>
                </div>
              </div>

              <div
                style={{
                  width: "15%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-start",
                }}
              >
                <div className="fontSize18Weight400">
                  {moment(item?.fromDate).format("DD-MM-YYYY")}
                  <br />
                  {moment(item?.fromDate).format("hh:mm a")}
                </div>
              </div>

              <div
                style={{
                  width: "15%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-start",
                }}
              >
                <div className="fontSize18Weight400">
                  {moment(item?.toDate).format("DD-MM-YYYY")}
                  <br />
                  {moment(item?.toDate).format("hh:mm a")}
                </div>
              </div>

              <div
                style={{
                  width: "15%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-start",
                }}
              >
                {item?.paidAt == null ? (
                  <div className="fontSize18Weight400">-</div>
                ) : (
                  <div className="fontSize18Weight400">
                    {moment(item?.paidAt).format("DD-MM-YYYY")}
                    <br />
                    {moment(item?.paidAt).format("hh:mm a")}
                  </div>
                )}
              </div>

              <div
                style={{
                  width: "8%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-start",
                }}
              >
                <div className="fontSize18Weight400">
                  ₹{item.payableAmount ?? 0}
                </div>
              </div>

              <StatusButton
                style={{
                  width: "10%",
                  backgroundColor:
                    item.status === "successful"
                      ? Colors.mainGreen01
                      : item.status === "Failed"
                      ? Colors.mainRed01
                      : Colors.mainOrange01,
                  borderColor:
                    item.status === "successful"
                      ? Colors.darkGreen
                      : item.status === "Failed"
                      ? Colors.darkRed
                      : Colors.darkOrange,
                  color:
                    item.status === "successful"
                      ? Colors.darkGreen
                      : item.status === "Failed"
                      ? Colors.darkRed
                      : Colors.darkOrange,
                }}
              >
                {item.status}
              </StatusButton>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AstrologerInvoiceList;
